export default "__VITE_ASSET__D4_MVO9z__"